import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaInformation from './media-information-model'
import {
  delete_mediaInformation,
  load_mediaInformations,
  store_mediaInformation,
} from './mediaInformation-service'

export const LoadMediaInformationsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaInformation',
  async (params: { uid: string }) => {
    return await load_mediaInformations(params)
  },
)

export const CreateMediaInformationAsync = createAsyncThunk<any, any>(
  'composer/create/mediaInformation',
  async (params: MediaInformation) => {
    return await store_mediaInformation(params)
  },
)

export const DeleteMediaInformationAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaInformation',
  async (params) => {
    return await delete_mediaInformation(params)
  },
)
